// extracted by mini-css-extract-plugin
export default {"navLink":"NavigationBar_navLink__Y9cU-","active":"NavigationBar_active__q159z"};